import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import TheatreSidebar from "../Layouts/TheatreSidebar";

import axios from "axios";
import $ from "jquery";

export class PostOpFInal extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      NauseaVomiting: "",
      MedicationsNauseaGiven: "",
      MedicationsNauseaTime: "",
      Pain: "",
      Analgesiagiven: "",
      AnalgesiaTime: "",
      IVfluidsRegime: "",
      IVfluidsAmount: "",
      Drugsgiven: "",
      Specimen: "",
      Takento: "",
      TakenBy: "",
      Skinintegrity: "",
      RecommendedPosition: "",
      Datetime:"",
      loading: false

      // 				visitid = request.headers["visitid"],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  componentDidMount() {
    $(".deadonehouryes").click(function () {
      $(".deadonereason").show();
    });
    $(".deadonehourno").click(function () {
      $(".deadonereason").hide();
    });

    $(".stillbirthyes").click(function () {
      $(".stillbirthtype").show();
    });
    $(".stillbirthno").click(function () {
      $(".stillbirthtype").hide();
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("visitId"),
      surgeryid: localStorage.getItem("surgeryid"),
    };
    event.preventDefault();
    console.log(this.state);
    axios
      .post(
        this.api_url+"optheatre/operativeorders/post/labour/postopfinal",
        this.state,
        { headers: headers }
      )
      .then((response) => {
        console.log(response);

        if (response.data["status"]) {
          $(".alert-success").show();
        }

        setTimeout(function () {
          window.location.href = "/theatre/observation/of/mother";
        }, 500);

        //
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const {
      NauseaVomiting,
      MedicationsNauseaGiven,
      MedicationsNauseaTime,
      Pain,
      Analgesiagiven,
      AnalgesiaTime,
      IVfluidsRegime,
      IVfluidsAmount,
      Drugsgiven,
      Specimen,
      Takento,
      TakenBy,
      Skinintegrity,
      RecommendedPosition,
      Datetime,
      loading
    } = this.state;
    return (
      <div>
        <Headers />
        <TheatreSidebar />

        <main>
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-4 p-2"></div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Post Operative Final
                  </p>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Nausea/Vomiting
                    </h6>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.handleChange}
                      value={NauseaVomiting}
                      name="NauseaVomiting"
                      required
                    />
                  </div>

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Medications Nausea Given
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={MedicationsNauseaGiven}
                      name="MedicationsNauseaGiven"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Medications Nausea Time
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={MedicationsNauseaTime}
                      name="MedicationsNauseaTime"
                      type="datetime-local"
                      required
                    />
                  </div>
                
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Pain
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={Pain}
                      name="Pain"
                      required
                    >
                      <optgroup label="" className="confirm_card">
                        <option selected disabled></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>

                
                </div>
              </div>

              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}></p>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Analgesia given
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Analgesiagiven}
                      name="Analgesiagiven"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Analgesia Time
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={AnalgesiaTime}
                      name="AnalgesiaTime"
                      type="datetime-local"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      IV fluids Regime
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={IVfluidsRegime}
                      name="IVfluidsRegime"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      IV fluids Amount
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={IVfluidsAmount}
                      name="IVfluidsAmount"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}></p>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Drugs given
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Drugsgiven}
                      name="Drugsgiven"
                      type="text"
                      required
                    />
                  </div>

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Specimen
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Specimen}
                      name="Specimen"
                      type="text"
                      required
                    />
                  </div>

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Skin integrity
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Skinintegrity}
                      name="Skinintegrity"
                      type="text"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Taken To
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Takento}
                      name="Takento"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Taken By
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={TakenBy}
                      name="TakenBy"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Recommended Position
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={RecommendedPosition}
                      name="RecommendedPosition"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Date And Time
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Datetime}
                      name="Datetime"
                      type="datetime-local"/>
                    
                  </div>
                </div>
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved Successfully.
              </div>

              <div className="row">
                <br />
                <br />
                <br />
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    {loading ? 'Loading' : 'Submit'}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default PostOpFInal;
